import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useHighFrequencyRefreshQuery } from '../../../queryDefaults/baseQueries/useHighFrequencyRefreshQuery';
import { IClinicSeatUsage } from '../ClinicSubscription';
import { ClinicSubscriptionsApi } from '../../../apis/ClinicSubscriptionsApi/ClinicSubscriptionsApi';

export function useGetClinicSeatUsage(clinicId: string) {
    return useHighFrequencyRefreshQuery<IClinicSeatUsage | undefined>({
        queryKey: [QueryKeys.clinicSeatUsage, clinicId],
        queryFn: async () => {
            const result = await ClinicSubscriptionsApi.getSeatUsage(clinicId);
            return result;
        },
        enabled: !!clinicId,
    });
} 